module.exports = __webpack_public_path__ + "img/about_us_2.6a161e8f.png";